/**
 * The helpers in this file are meant for external use.
 * We're exporting these.
 */
import { DateValue } from '@react-aria/datepicker';
import { RangeValue } from '@react-types/shared';

export const isEndDateBeforeStartDate = (
  dateRange?: RangeValue<DateValue> | null
): boolean => {
  if (dateRange && dateRange.end && dateRange.start) {
    return dateRange.end.compare(dateRange.start) < 0;
  } else {
    return false;
  }
};

export const isDateOutsideValidRange = (
  value?: DateValue | null,
  minValue?: DateValue | null,
  maxValue?: DateValue | null
): 'before' | 'after' | false => {
  if (value) {
    if (minValue && value.compare(minValue) < 0) {
      return 'before';
    }
    if (maxValue && value.compare(maxValue) > 0) {
      return 'after';
    }
    return false;
  } else {
    return false;
  }
};

export const rangeContainsUnavailableDate = (
  dateRange: RangeValue<DateValue> | null,
  isDateUnavailable?: (date: DateValue) => boolean
): boolean => {
  if (dateRange && !isEndDateBeforeStartDate(dateRange) && isDateUnavailable) {
    if (isDateUnavailable(dateRange.start)) {
      return true;
    } else {
      return rangeContainsUnavailableDate(
        { start: dateRange.start.add({ days: 1 }), end: dateRange.end },
        isDateUnavailable
      );
    }
  } else {
    return false;
  }
};
